<template>
    <layout-main :banner="banner" subtitle="医疗织物RFID洗涤管理系统">
        <template v-slot:content>
            <p class="text">基于RFID内置编码的唯一性，在每件被服上缝制一枚RFID洗衣标签（被服芯片），通过提供的RFID终端系统（手持设备、隧道机、智能柜、智能工作台等）实现被服入库、投放、收发、洗涤、周转、报废等全生命周期管理。</p>
            <p class="text">医疗织物RFID洗涤管理系统，将医院的医生护士工作服，病人制服，被褥，床单等加装RFID电子标签及可视化热塑标签，利用RFID手持式、隧道式装置，自动识别被服注册、清点、回收、洗涤、存储、领用等环节；同时实现被管理被服物品的状况查询、追踪、被服分拣等各个管理流程的智能管理模式，解决了医院在被服管理方面的后顾之忧。</p>
            <img src="@/assets/medicalFabric/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 出入库自动清点、节约人力成本；</p>
            <p class="text weight">· 一物一码各环节流程可追溯；</p>
            <p class="text weight">· 精细化管理、统计报表、便于核算成本；</p>
            <p class="text weight">· 洗涤管理平台涵盖：被服管理、工服管理、手术室行为管理；</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/assets/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
